/* import __COLOCATED_TEMPLATE__ from './indented-collection-option.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();